const NETWORK_CONSTANTS = {
  LOGIN: '/v1/accounts/login/',
  LOGOUT: '/v1/accounts/logout/',
  PROFILE: '/v1/accounts/',
  SIGNUP: '/v1/accounts/sign-up/',
  VERIFY_EMAIL: '/v1/accounts/verify-sign-up/',
  PRE_SIGNED_URL: '/v1/presigned-url/',
  FORGOT_PASSWORD_OTP: '/v1/accounts/forgot-password/',
  FORGOT_PASSWORD_OTP_VALIDATION: '/v1/accounts/verify-sign-up/',
  FORGOT_PASSWORD_VERIFY_OTP: '/v1/accounts/verify_otp/',
  FORGOT_PASSWORD_RESET_PWD: '/v1/accounts/reset-password/',
  CREATE_POST: '/v1/feeds/posts/',
  CAREERS: '/v1/accounts/careers',
  ABOUT: '/v1/accounts/about/',
  EXPERIENCES: '/v1/accounts/experiences/',
  EDUCATION: '/v1/accounts/educations/',
  CERTIFICATE: '/v1/accounts/certificates/',
  LINKS: '/v1/accounts/links/',
  SKILLS: '/v1/accounts/skills/',
  FETCH_POSTS: '/v1/feeds/',
  LIKE_UNLIKE_POST: '/v1/feeds/posts/like/',
  LIKED_USER: (likeId) => `/v1/feeds/posts/likes/${likeId}`,
  FETCH_POST_DETAILS: (postId) => `/v1/feeds/posts/${postId}/`,
  DELETE_POST: (postId) => `/v1/feeds/posts/${postId}/`,
  EDIT_POST: (postId) => `/v1/feeds/posts/${postId}`,
  SEARCH_USER: '/v1/accounts/search-user',
  CREATE_COMMENT: '/v1/feeds/posts/comment',
  GET_COMMENTS: (postId) => `/v1/feeds/posts/comment/${postId}`,
  DELETE_COMMENT: (id) => `/v1//feeds/posts/comment/${id}`,
  EDIT_COMMENT: (id) => `/v1/feeds/posts/comment/${id}`,
  OTHER_USER_PROFILE: (id) => `/v1/accounts/profile/user/${id}`,
  OTHER_USER_NETWORKING_COUNT: (id) => `/v1/accounts/follow/network/counts/user/${id}`,
  OTHER_USER_FOLLOW: (id) => `/v1/accounts/follow/${id}`,
  OTHER_USER_UNFOLLOW: (id) => `/v1/accounts/unfollow/${id}`,
  NETWORK_COUNT: '/v1/accounts/follow/network/counts',
  INVITE_PEOPLE: '/v1/accounts/invite/people',
  UPDATE_EMAIL_SEND_OTP: '/v1/accounts/update-email',
  UPDATE_EMAIL_RESEND_OTP_OLD: '/v1/accounts/resend-otp/old',
  UPDATE_EMAIL_RESEND_OTP_NEW: '/v1/accounts/resend-otp/new',
  NOTIFICATION_LIST: '/v1/notifications/',
  CHANGE_PASSWORD: '/v1/accounts/change-password',
  HELP_CENTER_CONTACT_ADMIN: '/v1/accounts/help-center/query',
  MARK_READ_PATH: '/v1/notifications/mark-as-read',
  UPDATE_EMAIL_VERIFY_OLD_EMAIL: '/v1/accounts/verify-email/old',
  UPDATE_EMAIL_VERIFY_NEW_EMAIL: '/v1/accounts/verify-email/new',
  MY_FOLLOWERS: '/v1/accounts/follow/followers',
  MY_NETWORK_COUNT: '/v1/accounts/my-network-count',
  MY_FOLLOWINGS: '/v1/accounts/follow/following',
  MY_CONNECTIONS: '/v1/accounts/connections',
  REPOST: '/v1/feeds/posts/share',
  FETCH_FOLLOW_REQUEST: '/v1/accounts/follow/requests',
  ACCEPT_FOLLOW_REQUEST: (id) => `/v1/accounts/follow/request/accept/${id}`,
  REJECT_FOLLOW_REQUEST: (id) => `/v1/accounts/follow/request/reject/${id}`,
  GET_PRIVACY_SETTINGS: '/v1/settings/privacy-setting',
  UPDATE_PRIVACY_SETTINGS: '/v1/settings/privacy-setting/',
  PRIVACY_SETTING_ADD_SPECIFIC_USERS: '/v1/settings/privacy-setting/specific-user',
  PRIVACY_SETTING_GET_SPECIFIC_USERS: '/v1/accounts/follow/network/specific',
  BLOCK_USER: (userId) => `/v1/accounts/block/user/${userId}`,
  UNBLOCK_USER: (userId) => `/v1/accounts/unblock/user/${userId}`,
  FETCH_ALL_FOLLOWERS_FOLLOWING_CONNECTION: '/V1/accounts/follow/network/specific/',
  DELETE_ACCOUNT: '/v1/accounts',
  BLOCKED_USERS_LIST: '/v1/accounts/block/list',
  REPORT_COMMENT: (commentId) => `/v1/report/comment/${commentId}`,
  REPORT_POST: (postId) => `/v1/report/post/${postId}`,
  REPORT_USER: (userId) => `/v1/report/user/${userId}`,
  ADD_EXPERIENCE: (careerId) => `/v1/accounts/careers/${careerId}/experiences`,
  EDIT_EXPERIENCE: (expId) => `/v1/accounts/experiences/${expId}`,
  EXPERIENCE_BY_ID: (expId) => `/v1/accounts/experiences/${expId}`,
  DELETE_EXPERIENCE: (expId) => `/v1/accounts/experiences/${expId}`,
  UPDATE_CAREER_MEDIA: (careerId) => `/v1/accounts/careers/${careerId}/medias/`,
  GET_ALL_EDUCATIONS: (careerId) => `/v1/accounts/careers/${careerId}/educations`,
  ADD_EDUCATION: (careerId) => `/v1/accounts/careers/${careerId}/educations`,
  EDIT_EDUCATION: (edId) => `/v1/accounts/educations/${edId}`,
  EDUCATION_BY_ID: (edId) => `/v1/accounts/educations/${edId}`,
  CAREER_BY_ID: (id) => `/v1/accounts/careers/${id}`,
  DELETE_EDUCATION: (edId) => `/v1/accounts/educations/${edId}`,
  ADD_CERTIFICATE: (careerId) => `/v1/accounts/careers/${careerId}/certificates`,
  EDIT_CERTIFICATE: (certId) => `/v1/accounts/certificates/${certId}`,
  GET_ALL_CERTIFICATES: (careerId) => `/v1/accounts/careers/${careerId}/certificates`,
  DELETE_CERTIFICATE: (certId) => `/v1/accounts/certificates/${certId}`,
  CERT_BY_ID: (certId) => `/v1/accounts/certificates/${certId}`,
  GET_ALL_CAREER_LINKS: (careerId) => `/v1/accounts/careers/${careerId}/links`,
  ADD_CAREER_LINK: (careerId) => `/v1/accounts/careers/${careerId}/links`,
  GET_ALL_CAREER_SKILLS: (careerId) => `/v1/accounts/careers/${careerId}/skills`,
  UPDATE_CAREER_SKILLS: (careerId) => `/v1/accounts/careers/${careerId}/skills`,
  GET_OTHER_USER_CAREER: (userId) => `/v1/accounts/careers/user/${userId}`,
  MYSELF_ADD_ABOUTME: '/v1/myself/about-me',
  FETCH_USER_INTERESTS: '/v1/accounts/interests/all/media/',
  FETCH_OTHER_USER_INTERESTS: (id) => `/v1/accounts/interests/all/media/user/${id}`,
  ALL_STATIC_INTERESTS: '/v1/interest',
  ADD_USER_INTEREST: '/v1/accounts/interests/',
  UPDATE_USER_INTEREST: (id) => `/v1/accounts/interests/${id}`,
  FETCH_USER_INTEREST_BY_ID: (id) => `/v1/accounts/interests/media/${id}`,
  DELETE_INTEREST: (id) => `/v1/accounts/interests/${id}`,
  SOFTSKILLS_LISTING: '/v1/softSkills',
  LANGUAGES_LISTING: '/v1/languages',
  ADD_MORE_YOU: '/v1/myself/more-about-you',
  MYSELF_DETAILS: '/v1/myself-details',
  FETCH_APPLIED_FILTERS: (queryParams) => `/v1/accounts/search-user?${queryParams}`,
  SEARCH_CAREERS: (search) => `/v1/accounts/career/search?search=${search}`,
  SEARCH_INTEREST: (search) => `/v1/accounts/interests/search?search=${search}`,
  SEARCH_EXPERIENCE: (search) => `/v1/accounts/experience/search?search=${search}`,
  SEARCH_EDUCATION: (search) => `/v1/accounts/education/search?search=${search}`,
  SEARCH_SKILLS: (search) => `/v1/accounts/skill/search?search=${search}`,
  ASSESMENT_ATTRIBUTES: '/v1/assessment/attributes/',
  ASSESMENT_MYERS_BRIGGS: '/v1/assessment/myers-briggs/',
  ASSESMENT_DISC: '/v1/assessment/disc-assessment',
  ASSESMENT_BIG_FIVE: '/v1/assessment/big-five/',
  SAVE_LOCATION: '/v1/myself/save/location',
  GET_MYSELF_OTHER_USER: (userId) => `/v1/myself/other-user/${userId}`,
};

export default NETWORK_CONSTANTS;
